'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = accounts;

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _accounts = require('../actions/accounts');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getBasicInfo),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(searchAccountsPaginated),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(addAccount),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(updateLoginStatus),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(editUserAccount),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(accounts);

function getBasicInfo(payload) {
  var getAccountHeader, basicInfo, getUserBasicInfo;
  return _regenerator2.default.wrap(function getBasicInfo$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          getAccountHeader = payload.getAccountHeader;
          basicInfo = new _webUtils.API();
          _context.next = 4;
          return basicInfo.get(_webUtils.Urls.account.getAccount, getAccountHeader);

        case 4:
          getUserBasicInfo = _context.sent;

          if (!_webUtils.STATUS.isSuccess(getUserBasicInfo.status)) {
            _context.next = 10;
            break;
          }

          _context.next = 8;
          return (0, _effects.put)({
            type: _accounts.ACCOUNTS.BASICINFO.SUCCEEDED,
            userBasicInfo: getUserBasicInfo.data,
            accountKey: getAccountHeader[0].value
          });

        case 8:
          _context.next = 12;
          break;

        case 10:
          _context.next = 12;
          return (0, _effects.put)({
            type: _accounts.ACCOUNTS.BASICINFO.FAILED
          });

        case 12:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function searchAccountsPaginated(action) {
  var searchAccountsAPI, authToken, header, response;
  return _regenerator2.default.wrap(function searchAccountsPaginated$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          searchAccountsAPI = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }];
          _context2.next = 5;
          return searchAccountsAPI.post(_webUtils.Urls.searchAccounts, action.payload, header);

        case 5:
          response = _context2.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context2.next = 11;
            break;
          }

          _context2.next = 9;
          return (0, _effects.put)((0, _accounts.searchAccountsSuccess)(_extends({}, response.data, action.payload)));

        case 9:
          _context2.next = 13;
          break;

        case 11:
          _context2.next = 13;
          return (0, _effects.put)((0, _accounts.searchAccountsFail)(_extends({}, action.payload)));

        case 13:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function addAccount(action) {
  var addUserAccountAPI, authToken, header, response;
  return _regenerator2.default.wrap(function addAccount$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          addUserAccountAPI = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }, {
            key: 'ComponentKey',
            value: 'accountmanagement'
          }];
          _context3.next = 5;
          return addUserAccountAPI.post(_webUtils.Urls.registerAccount, action.payload, header);

        case 5:
          response = _context3.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context3.next = 11;
            break;
          }

          _context3.next = 9;
          return (0, _effects.put)((0, _accounts.addUserAccountSuccess)(_extends({}, action.payload)));

        case 9:
          _context3.next = 13;
          break;

        case 11:
          _context3.next = 13;
          return (0, _effects.put)((0, _accounts.addUserAccountFail)(_extends({}, action.payload, {
            data: response.data
          })));

        case 13:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function updateLoginStatus(action) {
  var updateLoginStatusAPI, authToken, header, response;
  return _regenerator2.default.wrap(function updateLoginStatus$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          updateLoginStatusAPI = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }];
          _context4.next = 5;
          return updateLoginStatusAPI.post(_webUtils.Urls.updateLoginStatus, action.payload, header);

        case 5:
          response = _context4.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context4.next = 11;
            break;
          }

          _context4.next = 9;
          return (0, _effects.put)((0, _accounts.updateLoginStatusSuccess)(_extends({}, response.data, action.payload)));

        case 9:
          _context4.next = 13;
          break;

        case 11:
          _context4.next = 13;
          return (0, _effects.put)((0, _accounts.updateLoginStatusFail)(_extends({}, action.payload)));

        case 13:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function editUserAccount(action) {
  var editUserAccountAPI, authToken, header, response;
  return _regenerator2.default.wrap(function editUserAccount$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          editUserAccountAPI = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }];
          _context5.next = 5;
          return editUserAccountAPI.post(_webUtils.Urls.editAssistant, action.payload, header);

        case 5:
          response = _context5.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context5.next = 11;
            break;
          }

          _context5.next = 9;
          return (0, _effects.put)((0, _accounts.editUserAccountSuccess)(_extends({}, response.data, action.payload)));

        case 9:
          _context5.next = 13;
          break;

        case 11:
          _context5.next = 13;
          return (0, _effects.put)((0, _accounts.editUserAccountFail)(_extends({}, action.payload, response)));

        case 13:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function accounts() {
  return _regenerator2.default.wrap(function accounts$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeEvery)(_accounts.ACCOUNTS.BASICINFO.LOADING, getBasicInfo);

        case 2:
          _context6.next = 4;
          return (0, _effects.takeEvery)(_accounts.ACCOUNTS.SEARCH_ACCOUNTS.LOADING, searchAccountsPaginated);

        case 4:
          _context6.next = 6;
          return (0, _effects.takeEvery)(_accounts.ACCOUNTS.Add_USER_ACCOUNT.LOADING, addAccount);

        case 6:
          _context6.next = 8;
          return (0, _effects.takeEvery)(_accounts.ACCOUNTS.UPDATE_LOGIN_STATUS.LOADING, updateLoginStatus);

        case 8:
          _context6.next = 10;
          return (0, _effects.takeEvery)(_accounts.ACCOUNTS.EDIT_USER_ACCOUNTS.LOADING, editUserAccount);

        case 10:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}
module.exports = exports['default'];